<template>
  <div id="app" class="flex-grow-1 d-flex flex-column min-vh-100">
    <div v-if="isIE()" class="alert alert-warning mb-0 p-2 rounded-0" role="alert">
      You will experience limited functionality with your current browser. Please use this site with a modern browser such as <a href="https://www.mozilla.org/firefox" target="_blank" rel="noreferrer">Firefox</a><span v-if="afterEdgeRelease()">, <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_blank" rel="noreferrer">Edge</a></span> or <a href="https://www.google.com/chrome" target="_blank" rel="noreferrer">Chrome</a>.
    </div>
    <navbar :class="[$route.name === 'Login' ? 'd-none d-lg-block' : '']" />
    <acting-committee-bar />
    <router-view :class="['position-relative', isIE() ? 'min-vh-100-ie' : '']" />
  </div>
</template>

<script>
import HANDLERESIZE from '@/mixins/handleResize.js'
import FIELDLIST from '@/mixins/getFieldLists.js'
import navbar from '@/components/NavbarTop'
import ActingCommitteeBar from '@/components/ActingCommitteeBar'

export default {
  mixins: [FIELDLIST, HANDLERESIZE],
  components: {
    navbar,
    ActingCommitteeBar
  },
  methods: {
    isIE() {
      const userAgent = window.navigator.userAgent
      return userAgent.indexOf('Trident') > 0
    },
    afterEdgeRelease() {
      // Only recommending Edge after its Chromium release
      const pickedDatestr = '15-Jan-2020'
      const pickedDate = new Date(Date.parse(pickedDatestr.replace(/-/g, ' ')))
      const todaysDate = this.$store.state.currentDate ? new Date(this.$store.state.currentDate) : new Date()
      return pickedDate <= todaysDate
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/sass/app.scss';

.min-vh-100-ie {
  min-height: calc(100vh - 56px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue